import React from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { connect } from "react-redux";
import { getKey } from "../../../helpers/UrlHelper";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import NotAuthorized from "../../../components/NotAuthorized";
import { clientTypeConstants } from "../../../interaction/constants/clientType.constants";
import ExpoChat from "../Chat/ExpoChat/ExpoChat";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { interactionHelper } from "../../../helpers/interaction.helper";
import ExpoFileList from "../Files/ExpoFileList";
import { SideViewTabs2 } from "../SideViewTabs/SideViewTabs";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { templateActions } from "../../../store/actions/cms/template/template.action";
import { store } from "../../../store/configureStore";
import { videoCallConstants } from "../../constants/videoCall.constants";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import { insertFonts } from "../../../helpers/fontHelper";
import { toKebabCase } from "../../../helpers/cssHelper";
import OnVideCallModal from "../../shared/OnVideoCallModal";
import VideoFrame from "../VideoFrame/VideoFrame";
import Sound from "react-sound";
import rush from "../../../assets/audio/rush.mp3";
import ringing from "../../../assets/audio/ringing.mp3";
import chatNotification from "../../../assets/audio/chat.mp3";
import { ListItem, ListItemAvatar, ListItemText, Avatar, ListItemSecondaryAction, IconButton } from "@material-ui/core";
import { formatTime } from "../../../helpers/time.helper";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import CloseIcon from "@material-ui/icons/Close";
import "url-search-params-polyfill";
import { combineProps } from "../../../helpers/objectHelper";
import { GenericPlayer } from "../../../plugins/GenericPlayer";
import { ClientConnectionFallback, Loader } from "../../../digitalArena/utils/ClientConnectionFallback";
import { ConnectionStatus } from "../../../digitalArena/components/fallbacks/ConnectionStatus";
import { FontInjector } from "../../../digitalArena/components/MeetingLayout";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  rootGrid: {
    flexGrow: 1,
    height: "100vh",
  },
  paper: {
    padding: theme.spacing(2),
    height: "100%",
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      /*     width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: drawerWidth, */
      zIndex: 1900,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: 0,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

const pathConstants = {
  ACTIVITY: "ACTIVITY",
  COMMUNICATION: "COMMUNICATION",
};
const subPathConstants = {
  VIDEO: "VIDEO",
  CHAT: "CHAT",
};

class ExpoBoothLayout extends React.Component {
  state = {
    path: pathConstants.ACTIVITY,
    subPath: null,
    active: true,
    exhibitorId: null,
    eventId: null,
    connecting: false,
    exhibitorHosts: [],
    connectionList: [],
    exhibitorSettings: [],
    chat: [],
    anonymous: false,
    notAuthorized: false,
    forceDisc: false,
    init: false,
    clientName: "",
    eventCode: "",
    lang: "",
    profile: {},
    scroll: false,
    videoCallResponse: null,
    videoCallActive: false,
    videoCallTarget: null,
    nonAvailablePersons: [],
    callId: null,
    isCalling: null,
    VideoCallTimeout: 15,
    enableVideoMeeting: false,
    incommingCallSoundOn: false,
    ringingSoundOn: false,
    showBackToEventButton: false,
    meetingCode: null,
    messageSoundOn: false,
    enableChat: true,
    exhibitorName: "",
    snackbar: null,
  };
  componentDidMount() {
    let exhibitorId = this.props.match.params.id;
    const params = new URLSearchParams(this.props.location.search);
    const clientKey = params.get(getKey("clientkey", params));
    const lang = params.get(getKey("lang", params));
    if (lang) this.setState({ lang });
    document.body.style.overflow = "hidden";
    exhibitorId = parseInt(exhibitorId, 36);
    if (clientKey) {
      this.setClientKey(exhibitorId, clientKey);
    }
    this.callTimeout = {};
    this.setState({ connecting: true, exhibitorId });
    this.connectToHub(exhibitorId);
  }
  componentDidUpdate(prevProps, prevState) {
    const { connecting, dismissConnectionLoss, forceDisc, connected } = this.state;

    if (connected == false && prevState.connected == true && connecting == false) {
      this.tryReconnect();
      this.counter = setInterval(() => this.setState({ countdown: this.state.countdown + 1 }), 1000);
    } else if (this.state.countdown >= 60 && !connected && prevState.connected == false) {
      this.setState({ countdown: 0, connecting: false });
      this.tryReconnect();
    } else if (connected == true && prevState.connected == false && !this.state.connecting && this.hubConnection && this.hubConnection.connectionState == 1) {
      if (this.counter) clearInterval(this.counter);
      if (this.state.saveQueued) {
      }
      this.setState({ countdown: 0 });
    }
  }
  onNavigate = (path, subPath = null) => this.setState({ path, subPath });
  setClientKey = (id, key) => interactionHelper.setClientKey(null, key, id);
  getClientKey = (id) => interactionHelper.getClientKey(null, id);
  onGetExhibitorSettings = (exhibitorSettings) =>
    this.setState({
      exhibitorSettings,
      enableChat: exhibitorSettings.find((s) => s.name == "EnableChat").value2 == "True" ? true : false,
      enableVideoMeeting: exhibitorSettings.find((s) => s.name == "EnableVideoMeeting").value2 == "True" ? true : false,
      videoCallTimeout: exhibitorSettings.find((s) => s.name == "VideoCallTimeout") ? exhibitorSettings.find((s) => s.name == "VideoCallTimeout").value2 : 15,
    });

  onHandshake = (response) => {
    if (response.success) {
      this.setClientKey(this.state.exhibitorId, response.clientKey);
      this.setState({
        connected: true,
        connecting: false,
        profile: {
          companyName: response.companyName,
          fullName: response.clientName,
          profileImage: response.profileImage,
        },
        init: true,
        exhibitorName: response.exhibitorName,
        companyName: response.companyName,
        clientName: response.clientName,
        eventId: response.eventId,
        anonymous: response.anonymous,
        templateId: response.expoTemplateId,
        eventCode: response.eventCode,
        lang: this.state.lang || response.lang,
        showBackToEventButton: response.interactionShowBackToEventButtonExpo,
      });
      this.props.dispatch(cmsActions.getClientFonts(response.eventId));
      //get lang from handshake by event def
      init(response.eventId, "Exhibitor.Booth", this.state.lang || response.lang);

      if (response.expoTemplateId > 0) {
        store.dispatch(templateActions.get(response.expoTemplateId));
      }
      this.hubConnection.invoke("getActiveConnections", this.state.eventId, this.state.exhibitorId, [clientTypeConstants.INTERACTION_EXHIBITOR_HOST]).catch((err) => { });
      this.hubConnection.invoke("getExhibitorSettings", this.state.exhibitorId).catch((err) => { });
      this.getChat();

      this.hubConnection.invoke("getNoneAvailableCallers", this.state.exhibitorId).catch((err) => { });
      this.hubConnection.invoke("getExhibitorHosts", this.state.eventId, this.state.exhibitorId).catch((err) => { });

      if (!this.connectionTimer) {
        this.connectionTimer = setInterval(() => {
          this.hubConnection.invoke("getActiveConnections", this.state.eventId, this.state.exhibitorId, [clientTypeConstants.INTERACTION_EXHIBITOR_HOST]).catch((err) => { });
        }, 15000);
      }
      if (!this.orderListTimer) {
        this.orderListTimer = setInterval(() => {
          this.hubConnection.invoke("getExhibitorHosts", this.state.eventId, this.state.exhibitorId).catch((err) => { });
        }, 60000);
      }
    } else {
      console.error(response.message);
    }
  };
  onLike = (messageId) => {
    const { chat } = this.state;
    chat.map((c) => {
      c.messages.map((m) => {
        if (m.interactionChatId == messageId) {
          if (m.likes == null) m.likes = 0;
          m.likes += 1;
        }
      });
    });
    this.setState({ chat });
  };
  like = (messageId, target) => {
    this.hubConnection.invoke("like", messageId, target, this.state.exhibitorId);
  };
  onHostUpdate = ({ badgeNo, name, value }) => {
    const hosts = Array.from(this.state.exhibitorHosts);
    const host = hosts.find((h) => h.badgeNo == badgeNo);

    if (host) {
      var index = hosts.indexOf(host);
      if (index > -1) {
        if (name == "ProfileImage") hosts[index].profileImage = value;
        if (name == "ProfileBio") hosts[index].profileBio = value;
        this.setState({ exhibitorHosts: hosts });
      }
    }
  };
  onGetNoneAvailableCallers = (nonAvailablePersons) => {
    this.setState({ nonAvailablePersons });
  };
  connectToHub = (exhibitorId) => {
    try {
      if (!this.hubConnection) {
        this.hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
      }
    } catch (error) { }
    let clientKey = this.getClientKey(exhibitorId);

    this.hubConnection
      .start()
      .then(() => {
        this.hubConnection.on("onExpoHandshake", this.onHandshake);
        this.hubConnection.on("onNewConnection", this.onNewConnection);
        this.hubConnection.on("onNewDisconnection", this.onNewDisconnection);
        //optimize this instead of getting the whole chat
        /*         this.hubConnection.on("onChatMessageReceived", this.getChat); */
        /*            this.hubConnection.on("onMessageSent", this.getChat); */

        this.hubConnection.on("onGetChatMessage", this.onGetChat);
        this.hubConnection.on("onHostUpdate", this.onHostUpdate);
        this.hubConnection.on("onInitChat", this.getChat);
        this.hubConnection.on("onLikeMessage", this.onLike);
        this.hubConnection.on("onMessageSeen", this.getChat);
        this.hubConnection.on("onChatMessageReceived", this.onReceiveMessage);
        this.hubConnection.on("onSendChatMessage", this.onSendChatMessage);
        this.hubConnection.on("onReleased", this.onReleased);
        this.hubConnection.on("onOccupied", this.onOccupied);
        this.hubConnection.on("onVideoResponse", this.onVideoResponse);
        this.hubConnection.on("onVideoClosed", this.onVideoClosed);
        this.hubConnection.on("onVideoRequest", this.onVideoRequest);

        this.hubConnection.on("onGetExhibitorSettings", this.onGetExhibitorSettings);
        this.hubConnection.on("onGetNoneAvailableCallers", this.onGetNoneAvailableCallers);

        this.hubConnection.on("onGetActiveConnections", this.onGetActiveConnections);
        this.hubConnection.on("onGetActiveConnections", this.onGetActiveConnections);
        this.hubConnection.on("onGetExhibitorHosts", this.onGetExhibitorHosts);
        this.hubConnection.on("onForceDisconnect", this.onForceDisconnect);
        this.hubConnection.onclose(() => {
          this.setState({ connected: false });
        });

        this.hubConnection
          .invoke("expoHandshake", {
            exhibitorId: parseInt(exhibitorId),
            eventId: 0,
            clientType: clientTypeConstants.INTERACTION_EXHIBITOR_VISITOR,
            clientKey,
            userGuid: null,
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((error) => { });
  };

  onGetExhibitorHosts = (exhibitorHosts) => this.setState({ exhibitorHosts }, () => this.filterHostConnections());
  onInitChat = () => this.getChat();
  onGetChat = (chat) => (chat ? this.setState({ chat }) : null);

  onVideoClosed = () => {
    const { videoCallActive } = this.state;
    if (videoCallActive) {
      this.setState({
        videoCallActive: false,
        callId: null,
        videoCallResponse: videoCallConstants.TARGET_HANGUP,
        ringingSoundOn: false,
      });
      setTimeout(() => this.setState({ videoCallTarget: null }), 2000);
    }
  };
  videoRequestOnTimeout = (target, callId) => {
    const { videoCallActive } = this.state;
    const clientKey = this.getClientKey(this.state.exhibitorId);
    if (videoCallActive == false && target != clientKey && this.state.isCalling) {
      this.videoRequestResponse(false, target, callId);
    }
  };
  onVideoRequest = ({ target, meetingCode, callId }) => {
    const clientKey = this.getClientKey(this.state.exhibitorId);
    if (!this.state.isCalling && target != clientKey) {
      this.setState({
        isCalling: target,
        callId: callId,
        incommingCallSoundOn: true,
      });
      this.callTimeout[target] = setTimeout(() => this.videoRequestOnTimeout(target, callId), parseInt(this.state.VideoCallTimeout) * 1000);
    } else {
      this.setState({ callId });
    }
    this.setState({ meetingCode });
  };
  videoRequestResponse = (answer = true, target, callId, directed = false) => {
    const { exhibitorId } = this.state;
    clearTimeout(this.callTimeout[target]);
    this.setState({
      isCalling: null,
      incommingCallSoundOn: false,
      ringingSoundOn: false,
    });
    const clientKey = this.getClientKey(exhibitorId);
    if (answer == true) this.setState({ videoCallActive: true, videoCallTarget: target, callId });
    if (directed) {
      this.hubConnection.invoke("selfHangup", target, clientKey, parseInt(exhibitorId), callId);
    } else {
      this.hubConnection.invoke("videoRequestResponse", target, clientKey, parseInt(exhibitorId), answer, callId);
    }
  };
  onReleased = (res) => {
    let nonAvailablePersons = Array.from(this.state.nonAvailablePersons);
    nonAvailablePersons = nonAvailablePersons.filter((h) => h != res);
    this.setState({ nonAvailablePersons });
  };
  onOccupied = (res) => {
    const nonAvailablePersons = Array.from(this.state.nonAvailablePersons);
    nonAvailablePersons.push(res);
    this.setState({ nonAvailablePersons });
  };

  closeVideoCall = (target) => {
    this.setState({
      videoCallActive: false,
      videoCallResponse: videoCallConstants.SELF_HANGUP,
      ringingSoundOn: false,
    });
    setTimeout(() => this.setState({ videoCallTarget: null }), 2000);

    const { exhibitorId, callId } = this.state;
    let clientKey = this.getClientKey(exhibitorId);
    this.hubConnection.invoke("videoCallClosed", target, clientKey, parseInt(exhibitorId), callId).catch((err) => {
      console.error(err);
    });
  };
  onVideoResponse = ({ target, response, callId }) => {
    if (response && response != "SELF_HANGUP") {
      window.addEventListener("onclose", () => {
        if (this.state.videoCallActive) {
          this.closeVideoCall(this.state.videoCallTarget);
        }
        if (this.state.isCalling) {
          this.videoRequestResponse(false, this.state.isCalling, this.state.callId);
        }
      });
      window.addEventListener("unload", () => {
        if (this.state.videoCallActive) {
          this.closeVideoCall(this.state.videoCallTarget);
        }
        if (this.state.isCalling) {
          this.videoRequestResponse(false, this.state.isCalling, this.state.callId);
        }
      });
      this.setState({
        videoCallActive: true,
        videoCallTarget: target,
        callId,
        ringingSoundOn: false,
        incommingCallSoundOn: false,
      });
    } else {
      let clientKey = this.getClientKey(this.state.exhibitorId);
      let res = videoCallConstants.CALL_DENIED;
      if (response == "SELF_HANGUP") {
        res = videoCallConstants.SELF_HANGUP;
      }
      if (this.state.isCalling != target) {
        this.setState({ videoCallResponse: res, ringingSoundOn: false });
        setTimeout(() => this.setState({ videoCallTarget: null }), 2000);
      } else {
        this.setState({
          videoCallResponse: null,
          videoCallTarget: null,
          isCalling: false,
          ringingSoundOn: false,
          incommingCallSoundOn: false,
        });
      }
    }
  };
  videoRequest = (target) => {
    const { exhibitorId } = this.state;
    this.setState({
      videoCallTarget: target,
      videoCallResponse: null,
      ringingSoundOn: true,
    });
    let clientKey = this.getClientKey(exhibitorId);
    this.hubConnection.invoke("videoRequest", target, clientKey, parseInt(exhibitorId)).catch((err) => {
      console.error(err);
    });
  };

  tryReconnect = () => {
    if (!this.state.connected && !this.state.connecting) {
      this.setState({ connecting: true }, this.connectToHub(this.state.exhibitorId));
    }
  };
  onNewConnection = (conn) => {
    const { connectionList } = this.state;
    let newList = Array.from(connectionList);
    newList.push(conn);
    this.setState({ connectionList: newList });
  };
  onNewDisconnection = (connectionId) => {
    const { connectionList } = this.state;
    let newList = Array.from(connectionList);
    let dConn = newList.find((el) => el.connectionId == connectionId);
    if (dConn) {
      newList.splice(newList.indexOf(dConn), 1);
      this.setState({ connectionList: newList });
    }
  };
  onGetActiveConnections = (list) => {
    this.setState({ connectionList: list });
  };
  onMessageSeen = (target) => {
    const chat = this.state.chat;
    chat.map((c) => {
      if (c.target == target) {
        c.messages.map((m) => {
          c.seen = true;
          m.seen = true;
        });
      }
    });
    this.setState({ chat });
  };
  setMessageSeen = (c) => {
    let clientKey = this.getClientKey(this.state.exhibitorId);
    const notReadMessage = c.messages.find((c) => c.seen == false && c.receiver == clientKey);
    if (notReadMessage) {
      this.hubConnection.invoke("setMessageSeen", notReadMessage.receiver, notReadMessage.sender, this.state.exhibitorId).catch((err) => { });
    }
  };
  onForceDisconnect = (res) => {
    if (res === "NOT_AUTHORIZED") {
      this.setState({ notAuthorized: true, connected: false });
      this.hubConnection.stop();
    } else {
      this.hubConnection.stop();
      this.setState({ forceDisc: true, connected: false });
    }
  };

  getChat = () => {
    this.hubConnection.invoke("getChatMessages", this.state.eventId, this.getClientKey(this.state.exhibitorId), `Expo:${this.state.exhibitorId}`, false);
  };
  onReceiveMessage = (res) => {
    const chat = Array.from(this.state.chat);
    const resChat = chat.find((c) => c.target == res.sender);
    if (resChat) {
      let index = chat.indexOf(resChat);
      if (index > -1) {
        chat[index].messages.push(res);
        chat[index].previewText = res.message;
        chat[index].previewPreFix = res.senderFirstName + " " + res.senderLastName;
        chat[index].lastChange = res.inserted;
      }
    } else {
      chat.push({
        lastChange: res.inserted,
        messages: [res],
        previewText: res.message,
        previewPreFix: res.senderFirstName + " " + res.senderLastName,
        target: res.sender,
        seen: false,
      });
    }
    const { selectedChat } = this.state;
    if (!selectedChat || (selectedChat && selectedChat != res.sender)) {
      this.setState({
        snackbar: {
          lastChange: res.inserted,
          previewText: res.message,
          previewPreFix: "",
          target: res.sender,
        },
        messageSoundOn: true,
      });
      setTimeout(() => this.setState({ messageSoundOn: false }), 2000);
    }
    this.setState({ chat, scroll: true });
    setTimeout(() => this.setState({ scroll: false }), 1000);

    /*  setTimeout(() => this.setState({ update: false }), 1000) */
  };
  onSendChatMessage = (res) => {
    const chat = Array.from(this.state.chat);
    const resChat = chat.find((c) => c.target == res.receiver);
    if (resChat) {
      let index = chat.indexOf(resChat);
      if (index > -1) chat[index].messages.push(res);
      /* 
                        resChat.previewText = res.message;
                        resChat.previewPrefix = res.sender == 'MODERATOR' ? 'You' : res.senderFirstName + ' ' + res.senderLastName;
                        resChat.lastChange = res.inserted; */
    } else {
      chat.push({
        lastChange: res.inserted,
        messages: [res],
        previewText: res.message,
        previewPreFix: "",
        target: res.receiver,
        seen: false,
      });
    }

    this.setState({ chat, scroll: true });
    setTimeout(() => this.setState({ scroll: false }), 1000);
  };
  filterHostConnections = () => {
    const { exhibitorHosts, connectionList } = this.state;
    const filteredList = connectionList.filter((c) => {
      return exhibitorHosts.find((eh) => eh.badgeNo == c.clientKey);
    });
    this.setState({ connectionList: filteredList });
  };
  sendMessage = (t, message) => {
    const { exhibitorId, eventId } = this.state;
    let clientKey = this.getClientKey(exhibitorId);
    this.hubConnection.invoke("sendChatMessage", eventId, clientKey, t.badgeNo, message, `Expo:${exhibitorId}`, '', false, false);
  };
  selectedChat = (target) => {
    const { snackbar } = this.state;
    if (!target) {
      this.setState({ selectedChat: null });
      return;
    }
    if (snackbar && snackbar.target == target.badgeNo) {
      this.setState({ snackbar: null, selectedChat: target.badgeNo });
    } else {
      this.setState({ selectedChat: target.badgeNo });
    }
  };
  render() {
    const { exhibitorHosts, connected, enableChat, chat, connecting, connectionList, notAuthorized, videoCallTarget, exhibitorId, companyName, clientName, eventId, eventCode, videoCallActive } =
      this.state;
    const { template } = this.props;
    const { fonts } = this.props.cms;
    if (notAuthorized === true) return <NotAuthorized />;
    let clientKey = this.getClientKey(this.state.exhibitorId);
    const connectionsProps = { hubConnection: this.hubConnection, ...this.state };

    if (this.state.forceDisc && !connected) return <ClientConnectionFallback {...connectionsProps} />;
    if (!this.state.init) return <Loader />;
    return (
      <div>
        {template && template.template ? <FontInjector fonts={fonts} template={template.template.content} /> : null}
        <ConnectionStatus {...connectionsProps} />
        {fonts !== undefined && (
          <style
            dangerouslySetInnerHTML={{
              __html: insertFonts(this.props.cms.fonts),
            }}
          />
        )}
        {this.state.isCalling && connected ? (
          <OnVideCallModal
            target={exhibitorHosts.find((eh) => eh.badgeNo == this.state.isCalling)}
            deny={() => this.videoRequestResponse(false, this.state.isCalling, this.state.callId)}
            accept={() => this.videoRequestResponse(true, this.state.isCalling, this.state.callId)}
          />
        ) : null}
        {videoCallTarget && connected ? (
          <VideoFrame
            targetPerson={exhibitorHosts.find((eh) => eh.badgeNo == videoCallTarget).name}
            displayName={clientName}
            exhibitorHosts={exhibitorHosts}
            chat={chat}
            clientKey={clientKey}
            template={template}
            callId={this.state.callId}
            like={this.like}
            eventCode={eventCode}
            eventId={eventId}
            lang={this.state.lang}
            clientName={this.state.clientName}
            nonAvailablePersons={this.state.nonAvailablePersons}
            videoRequest={this.videoRequest}
            closeVideoCall={this.closeVideoCall}
            videoCallActive={this.state.videoCallActive}
            scroll={this.state.scroll}
            videoCallResponse={this.state.videoCallResponse}
            videoCallTarget={this.state.videoCallTarget}
            settings={this.state.exhibitorSettings}
            connectionList={connectionList}
            sendMessage={this.sendMessage}
            meetingCode={this.state.meetingCode}
            videoResponse={this.videoRequestResponse}
            setMessageSeen={this.setMessageSeen}
          />
        ) : null}
        <CenteredGrid
          exhibitorHosts={exhibitorHosts}
          chat={chat}
          clientKey={clientKey}
          template={template}
          callId={this.state.callId}
          like={this.like}
          eventCode={eventCode}
          profile={this.state.profile}
          eventId={eventId}
          anonymous={this.state.anonymous}
          exhibitorId={exhibitorId}
          exhibitorName={this.state.exhibitorName}
          enableChat={enableChat}
          selectedChat={this.state.selectedChat}
          clientName={this.state.clientName}
          nonAvailablePersons={this.state.nonAvailablePersons}
          videoRequest={this.videoRequest}
          closeVideoCall={this.closeVideoCall}
          videoCallActive={this.state.videoCallActive}
          scroll={this.state.scroll}
          videoCallResponse={this.state.videoCallResponse}
          videoCallTarget={this.state.videoCallTarget}
          lang={this.state.lang}
          settings={this.state.exhibitorSettings}
          enableVideoMeeting={this.state.enableVideoMeeting}
          connectionList={connectionList}
          sendMessage={this.sendMessage}
          showBackToEventButton={this.state.showBackToEventButton}
          videoResponse={this.videoRequestResponse}
          selectChat={(target) => this.selectedChat(target)}
          setMessageSeen={this.setMessageSeen}
        />
        {this.state.incommingCallSoundOn ? <Sound url={rush} loop={true} playStatus={this.state.incommingCallSoundOn ? Sound.status.PLAYING : Sound.status.STOPPED} /> : null}
        {this.state.ringingSoundOn ? <Sound url={ringing} loop={true} playStatus={this.state.ringingSoundOn ? Sound.status.PLAYING : Sound.status.STOPPED} /> : null}
        {/*    {this.state.messageSoundOn ? */} <Sound url={chatNotification} loop={true} playStatus={this.state.messageSoundOn ? Sound.status.PLAYING : Sound.status.STOPPED} /> {/* : null} */}
        {this.state.snackbar ? (
          <div
            className="message-snackbar"
            onClick={() =>
              this.selectedChat({
                ...this.state.snackbar,
                badgeNo: this.state.snackbar.target,
              })
            }
          >
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar style={{ background: "rgb(116 147 228)" }}>
                  <ChatBubbleIcon
                    style={{
                      color: "#fff",
                    }}
                  />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography>
                    {this.state.exhibitorHosts.find((e) => e.badgeNo == this.state.snackbar.target) ? this.state.exhibitorHosts.find((e) => e.badgeNo == this.state.snackbar.target).name : null}
                  </Typography>
                }
                secondary={
                  <div style={{ color: "#eee" }}>
                    {this.state.snackbar.previewText.substring(0, 20)} • {formatTime(this.state.snackbar.lastChange)}
                  </div>
                }
              />
              <ListItemSecondaryAction>
                <IconButton style={{ color: "#eee" }} onClick={() => this.setState({ snackbar: null })}>
                  <CloseIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </div>
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    template: state.template,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(ExpoBoothLayout);

function CenteredGrid({
  exhibitorHosts,
  template,
  setMessageSeen,
  clientKey,
  scroll,
  chat,
  anonymous,
  sendMessage,
  settings = [],
  clientName,
  connectionList,
  like = () => null,
  closeVideoCall = () => null,
  videoRequest = () => null,
  nonAvailablePersons = [],
  videoCallTarget = null,
  videoCallResponse = null,
  videoCallActive = false,
  eventCode = null,
  eventId = null,
  exhibitorName,
  exhibitorId,
  enableChat = true,
  videoResponse = () => null,
  callId = null,
  profile = {},
  setScroll = () => null,
  lang = null,
  selectedChat = null,
  selectChat = () => null,
  showBackToEventButton = false,
  enableVideoMeeting = false,
}) {
  const classes = useStyles();
  return (
    <div className={classes.rootGrid}>
      <Grid
        container
        style={{
          height: "100%",
          marginTop: "-0px",
          background: template && template.template ? template.template.content.main.background : undefined,
        }}
        spacing={3}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "auto",
            display: "flex",
            height: "calc(100vh - 40px)",
            minWidth: "767px !important",
          }}
        >
          <Grid
            item
            xs={6}
            md={6}
            lg={7}
            style={{
              padding: "0px 30px",
              height: "calc(100vh - 40px)",
              margin: "auto",
              paddingRight: 20,
            }}
          >
            <Paper
              className={classes.paper}
              style={{
                padding: 0,
                boxShadow: "none",
                background: "transparent",
              }}
            >
              <ContentView
                showBackToEventButton={showBackToEventButton}
                settings={settings}
                template={template && template.template ? template.template : undefined}
                eventCode={eventCode}
                eventId={eventId}
                exhibitorName={exhibitorName}
                exhibitorId={exhibitorId}
                clientKey={clientKey}
              />
            </Paper>
          </Grid>
          <Grid
            item
            xs={6}
            md={6}
            lg={5}
            style={{
              padding: "0px 10px",
              paddingRight: 30,
              height: "calc(100vh - 40px)",
              margin: "auto",
            }}
          >
            <div
              style={{
                minHeight: "calc(50% - 15px)",
                maxHeight: "calc(50% - 15px)",
                marginBottom: 30,
                backgroundColor: "#fff",
                borderRadius: 4,
              }}
            >
              {/*  <div style={template && template.template ? { fontFamily: template.template.content.subtitle.fontFamily, textAlign: 'left', color: '#222', paddingLeft: 23, paddingTop: 20, paddingBottom: 15, fontSize: 18 } : { color: '#222', fontSize: 18, textAlign: 'left', paddingLeft: 23, paddingTop: 10, paddingBottom: 15 }}>
                                <EventLabel2 name="Exhibitors" groupName="Exhibitor.Booth" />
                            </div> */}
              <ExpoChat
                exhibitorHosts={exhibitorHosts}
                chat={chat}
                template={template && template.template ? template.template.content : undefined}
                scroll={scroll}
                setScroll={setScroll}
                enableChat={enableChat}
                like={like}
                videoResponse={videoResponse}
                videoCallResponse={videoCallResponse}
                videoCallTarget={videoCallTarget}
                nonAvailablePersons={nonAvailablePersons}
                videoRequest={videoRequest}
                closeVideoCall={closeVideoCall}
                callId={callId}
                lang={lang}
                anonymous={anonymous}
                selectedChat={selectedChat}
                selectChat={selectChat}
                clientName={clientName}
                videoCallActive={videoCallActive}
                clientKey={clientKey}
                connectionList={connectionList}
                sendMessage={sendMessage}
                enableVideoMeeting={enableVideoMeeting}
                setMessageSeen={setMessageSeen}
                profile={profile}
              />
            </div>
            <div
              style={{
                minHeight: "calc(50% - 15px)",
                maxHeight: "calc(50% - 15px)",
                backgroundColor: "#fff",
                borderRadius: 4,
              }}
            >
              <SideViewTabs2
                template={template && template.template ? template.template.content : undefined}
                fileView={
                  <div
                    style={{
                      padding: "5px",
                      paddingRight: "0px",
                      margin: "10px 0px",
                      minHeight: "calc(100%)",
                      maxHeight: "calc(100%)",
                    }}
                  >
                    <ExpoFileList
                      clientKey={clientKey}
                      eventId={eventId}
                      exhibitorId={exhibitorId}
                      template={template && template.template ? template.template.content : undefined}
                      files={settings.filter((s) => s.name == "File")}
                    />
                  </div>
                }
                linkView={
                  <div
                    style={{
                      padding: "5px",
                      paddingRight: "0px",
                      margin: "10px 0px",
                      minHeight: "calc(100%)",
                      maxHeight: "calc(100%)",
                    }}
                  >
                    <ExpoFileList
                      eventId={eventId}
                      exhibitorId={exhibitorId}
                      clientKey={clientKey}
                      template={template && template.template ? template.template.content : undefined}
                      links={true}
                      files={settings.filter((s) => s.name == "Link")}
                    />
                  </div>
                }
              />
            </div>
          </Grid>
        </div>
      </Grid>
    </div>
  );
}

function ContentView({ settings = [], template = undefined, eventId, exhibitorId, eventCode = null, clientKey = null, showBackToEventButton = false, exhibitorName }) {
  const classes = useStyles();

  const infoText = () => {
    let infoText = settings.find((s) => s.name == "Infotext");
    return infoText ? infoText.value2 : "";
  };
  const logoImage = () => {
    let infoText = settings.find((s) => s.name == "LogoImage");
    return infoText ? infoText.value : "";
  };
  const startVideo = () => {
    let startVideo = settings.find((s) => s.name == "StartVideo");
    return startVideo ? startVideo.value2 : "";
  };
  let startVid = /*  embedLink( */ startVideo(); /* ) */
  let contentText = infoText();
  return (
    <Card
      className={classes.root}
      style={{
        display: "block",
        height: "100%",
        boxShadow: "none",
        padding: "0px",
        width: "100%",
        background: "#fff",
      }}
    >
      <CardContent style={{ height: "19%", width: "100%", position: "relative" }}>
        <Grid style={{ display: "flex" }}>
          <Grid item={true} xs={6}>
            <div
              style={{
                textAlign: "left",
                /* height: '50%', */ paddingLeft: "13px" /* paddingTop: 15 */,
              }}
            >
              {showBackToEventButton ? (
                <Button
                  onClick={(e) => {
                    window.location.href = `./digitalarena/${eventCode}/?clientKey=${clientKey}`;
                  }}
                  style={
                    template && template.content
                      ? {
                        ...template.content.button,
                        marginLeft: "1.66%",
                        padding: "3px 12px",
                        width: "auto",
                        fontSize: 16,
                      }
                      : {
                        marginLeft: "1.66%",
                        padding: "3px 12px",
                        width: "auto",
                      }
                  }
                >
                  <EventLabel2 name="BackToMainEvent" groupName="Exhibitor.Booth" />
                </Button>
              ) : null}
            </div>
          </Grid>
          <Grid item={true} xs={6} style={{ position: "relative", textAlign: "right" }}>
            {eventCode == "b9e695e8" ? (
              <div
                style={{
                  fontFamily: template ? template.content.subtitle.fontFamily : "unset",
                  marginLeft: "auto",
                  fontSize: "1.2rem",
                  backgroundColor: "#222",
                  borderRadius: 4,
                  paddingTop: 2,
                  paddingRight: "10px",
                  width: "230px",
                  color: "#fff",
                }}
              >
                Partner till Byggforum
              </div>
            ) : null}
          </Grid>
        </Grid>
        {logoImage() ? (
          <div className="expo-logo-image">
            <img src={logoImage()} />
          </div>
        ) : (
          <h1 style={template ? { ...template.content.title, marginTop: 10, textAlign: "left", paddingLeft: 15 } : { textAlign: "left", paddingLeft: 15, marginTop: 10 }}>{exhibitorName}</h1>
        )}
      </CardContent>

      <CardContent
        style={{
          height: startVid ? "40%" : "81%",
          width: "100%",
          display: "inline-flex",
        }}
      >
        <Card className={classes.root} style={{ margin: 5, height: "100%", boxShadow: "none" }}>
          <CardContent style={{ padding: 5, width: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <style>
                {"#expo-custom p,#expo-custom h1,#expo-custom h2 { color: #5e5e5e;} "}
                {template && template.content ? `${toKebabCase(template.content, true)}` : ""}
                {template && template.content ? `${toKebabCase(template.scrollbar, true, true)}` : ""}
              </style>
              <div
                className="styleWrapper jir-scroll"
                id="expo-custom"
                style={{
                  maxHeight: !startVid ? "calc(100vh - 245px)" : "calc(50vh - 160px)",
                  overflowY: "auto",
                  padding: "10px",
                  textAlign: "left",
                  overflowX: "hidden",
                  minWidth: !contentText || (contentText && contentText == "*Infotext*") ? 723 : "unset",
                }}
                dangerouslySetInnerHTML={{
                  __html: contentText
                    .toString()
                    .replace(/\[clientkey\]/gi, clientKey)
                    .replace(/\[badgeno\]/gi, clientKey),
                }}
              ></div>
            </div>
          </CardContent>
        </Card>
      </CardContent>
      {startVid ? (
        <CardContent
          style={{
            height: "40%",
            width: "100%",
            display: "inline-flex",
            padding: "0px 16px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              margin: "auto",
              width: "100%",
              height: "100%",
              background: "#222",
            }}
          >
            <GenericPlayer
              {...combineProps([
                {
                  eventId,
                  exhibitorId,
                  url: startVid,
                  clientKey,
                },
              ])}
            />
          </div>
        </CardContent>
      ) : null}
    </Card>
  );
}
